import { useState, useCallback } from "react"
import  API  from "../../API"
import useSesion from "../Sesion"
import dayjs from "dayjs";

/** ISO, legado "YYYY-MM-DD HH:mm:ss…", timestamp o { $date } → "YYYY-MM-DD" */
function diaDesdeApi(val) {
    if (val == null || val === "") return ""
    if (typeof val === "object" && val !== null && val.$date != null) {
        return diaDesdeApi(val.$date)
    }
    if (typeof val === "number" && Number.isFinite(val)) {
        const d = dayjs(val)
        return d.isValid() ? d.format("YYYY-MM-DD") : ""
    }
    const s = String(val).trim()
    const m = s.match(/^(\d{4}-\d{2}-\d{2})/)
    if (m) return m[1]
    const d = dayjs(s)
    return d.isValid() ? d.format("YYYY-MM-DD") : ""
}

export function usePrueba(){
    const [pruebas, setPruebas] = useState([])
    const {usuario} = useSesion()
    
    const getPrueba = async (id) => {
        const { data } = await API(`prueba/${id}`)
        setPruebas([data.doc])
        console.log(data.doc)
    }
    
    const getPruebas = async (payload) => {
        const raw0 = payload?.fecha?.[0]?.toDate?.() ?? payload?.fecha?.[0]
        const raw1 = payload?.fecha?.[1]?.toDate?.() ?? payload?.fecha?.[1]
        const d0 = dayjs(raw0)
        const d1 = dayjs(raw1)
        const fi = d0.isValid() ? d0.toDate() : dayjs("2020-01-01").startOf("day").toDate()
        const ff = d1.isValid() ? d1.toDate() : dayjs().endOf("day").toDate()

        const params = {
                        fi,
                        ff,
                        mm: payload?.momento,
                        tp: payload?.tipoPrueba,
                        in: usuario?.rol === 'Admin' ? payload?.institucion : usuario?.institucion,
                        at: payload?.atleta
                        }
    
        const { data } = await API('prueba', { params })
        setPruebas(data?.docs ?? [])
    }
    
    const deletePrueba=async (prueba)=>{
        await API.delete(`prueba/${prueba._id}`)      
        setPruebas(pruebas.filter((p)=>p._id!==prueba._id))
    }
    const cargarFecha = useCallback(async (form, setFiltroPrueba) => {
        if (!usuario) return
        if (usuario.rol !== "Admin" && !usuario.institucion) return

        try {
            const params = {
                fi: dayjs("2020-01-01").toDate(),
                ff: dayjs().toDate(),
                in: usuario.rol === "Admin" ? "" : usuario.institucion,
            }

            const { data } = await API("prueba", { params })
            const docs = data.docs ?? []

            const dias = []
            const seen = new Set()
            for (const doc of docs) {
                const raw = doc.updatedAt ?? doc.createdAt
                let d = diaDesdeApi(raw)
                if (!d) {
                    const dj = dayjs(raw)
                    if (dj.isValid()) d = dj.format("YYYY-MM-DD")
                }
                if (d && !seen.has(d)) {
                    seen.add(d)
                    dias.push(d)
                }
            }
            dias.sort()

            const minD = dias.length ? dias[0] : "2020-01-01"
            const maxD = dias.length ? dias[dias.length - 1] : dayjs().format("YYYY-MM-DD")

            const inicio = dayjs(minD)
            const fin = dayjs(maxD)
            if (!inicio.isValid() || !fin.isValid()) return

            setFiltroPrueba((prev) => ({ ...prev, fecha: [inicio, fin] }))
            form.setFieldsValue({
                fecha: [inicio, fin.add(1, "day")],
            })
            form.submit()
        } catch (err) {
            console.log("Error cargando Fechas", err)
        }
    }, [usuario])

    return{
        pruebas,
        getPruebas,
        deletePrueba,
        cargarFecha,
        getPrueba
    }
}